export const COLLECTIONS = {
  USERS: 'users',
  COGNIPRINTS: 'cogniprints',
  CONTENT: 'content',
  LEARNING_PATHS: 'learningPaths',
  TUTOR_SESSIONS: 'tutorSessions',
  WAITLIST: 'waitlist',
  RECALIBRATION_SCHEDULES: 'recalibrationSchedules',
  RECALIBRATION_SESSIONS: 'recalibrationSessions',
  DAY14_OFFERS: 'day14Offers',
  MONTHLY_REPORTS: 'monthlyReports',
  PRODUCT_BACKLOG: 'productBacklog',
  CLAUDE_CALL_METRICS: 'claudeCallMetrics',
  REVIEWS: 'reviews',
  TONE_PREFERENCES: 'tonePreferences',
} as const;
